import { MatchplayRegistration } from '../../../../models/MatchplayRegistration';

export const DragItemType = 'MatchplayRegistration';

export interface DragItem {
    groupIndex: number;
    registration: MatchplayRegistration;
}
